import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { LayoutModule } from "../../../../app/theme/layouts/layout.module";
import { SharedModule } from "../../../../app/freightconfirmation/app.sharemodule";
import { RouterModule } from "@angular/router";
import { PaymentMadeComponent } from "../payment-made.component";
import { DocumentsharedModule } from "../../../../app/documentshared/documentshared.module";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../../../theme/home/translateConfig.service";
import { ShortcutMenuModule } from "../../../shortcut-menu/shortcut-menu.module";
import { Network_SharedModule } from "../../../../app/Network/network/network_shared.module";
import { NumberToWordsPipe } from "../number-to-words.pipe";
// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LayoutModule,
    SharedModule,
    RouterModule,
    DocumentsharedModule,
    HttpClientModule,
    //added by vithujan 22-02-2023
    ShortcutMenuModule,
    //end
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    Network_SharedModule,
  ],
  declarations: [PaymentMadeComponent, NumberToWordsPipe],
  exports: [PaymentMadeComponent, NumberToWordsPipe],
  providers: [TranslateConfigService],
})
export class PaymentMadeSharedModule { }
